import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FournisseursModel } from '../../models/';

@Component({
  selector: 'fs-creancier-selector',
  templateUrl: './creancier-selector.component.html',
  styleUrls: ['./creancier-selector.component.sass']
})

export class CreancierSelectorComponent {
  @Input() supplierList: FournisseursModel[];
  @Input() selectedSupplierId: number;
  @Output() selectSupplier = new EventEmitter<number>();

  constructor() { }

  onFournisseurSelected(supplier: FournisseursModel) {
    if (supplier.FournisseurId !== this.selectedSupplierId) {
      this.selectSupplier.emit(supplier.FournisseurId);
    }
  }
}
